const newVersionUrls = [
  '/app/auth/meal/save',
  '/app/auth/appmeal/page',
  '/app/auth/appmeal/save',
  '/app/auth/meal/list',
  '/app/auth/appmeal/list',
  '/app/auth/menu/import',
  '/app/access/v2/login'
]

export default newVersionUrls



// WEBPACK FOOTER //
// ./src/fetch/newVersion.js